"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _angieslistReactComponents = require("angieslist-react-components");
var _angieslistStyles = require("angieslist-styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var green = _angieslistStyles.stylesColors.green,
  textColorAlt = _angieslistStyles.stylesColors.textColorAlt,
  white = _angieslistStyles.stylesColors.white;
var FeaturedSPInfoHover = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FeaturedSPInfoHover, _React$Component);
  var _super = _createSuper(FeaturedSPInfoHover);
  function FeaturedSPInfoHover() {
    var _context, _context2, _context3;
    var _this;
    (0, _classCallCheck2["default"])(this, FeaturedSPInfoHover);
    _this = _super.call(this);
    _this.handleToggle = (0, _bind["default"])(_context = _this.handleToggle).call(_context, (0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseEnter = (0, _bind["default"])(_context2 = _this.handleMouseEnter).call(_context2, (0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseLeave = (0, _bind["default"])(_context3 = _this.handleMouseLeave).call(_context3, (0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      show: false,
      popOverEntered: false,
      showFeaturedProPopOverDetail: false
    };
    return _this;
  }
  (0, _createClass2["default"])(FeaturedSPInfoHover, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        show: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var _this2 = this;
      (0, _setTimeout2["default"])(function () {
        var popOverEntered = _this2.state.popOverEntered;
        if (!popOverEntered) {
          _this2.setState({
            show: false
          });
        }
      }, 250);
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      var show = this.state.show;
      this.setState({
        show: !show
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        showFeaturedProPopOverDetail = _this$state.showFeaturedProPopOverDetail,
        show = _this$state.show;
      var singleFeaturedPro = this.props.singleFeaturedPro;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
        id: "fooButton",
        role: "presentation",
        style: {
          fontSize: singleFeaturedPro ? '18px' : '12px',
          color: singleFeaturedPro ? white : textColorAlt
        },
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        className: singleFeaturedPro ? 'icon icon-info-circled' : 'icon icon-info',
        ref: function ref(_ref) {
          _this3.buttonRef = _ref;
        },
        onClick: this.handleToggle
      }), /*#__PURE__*/React.createElement(_angieslistReactComponents.Overlay, {
        rootClose: true,
        onHide: function onHide() {
          return _this3.setState({
            show: false
          });
        },
        show: show,
        placement: "bottom",
        target: this.buttonRef
      }, /*#__PURE__*/React.createElement(_angieslistReactComponents.Popover, {
        id: "featuredSPInfoPopover"
      }, /*#__PURE__*/React.createElement("div", {
        onMouseEnter: function onMouseEnter() {
          return _this3.setState({
            popOverEntered: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this3.setState({
            show: false,
            popOverEntered: false
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '10px',
          color: green
        }
      }, /*#__PURE__*/React.createElement("strong", null, "Why does this Business look different?")), /*#__PURE__*/React.createElement("small", null, "These profiles are placements that are reserved for our Certified Businesses. The Certified Businesses who appear in these profiles may appear based on criteria other than their star rating or number of reviews."), !showFeaturedProPopOverDetail ? [/*#__PURE__*/React.createElement("small", {
        key: "0"
      }, ' For more details about Angi Certification '), /*#__PURE__*/React.createElement(_angieslistReactComponents.Button, {
        id: "featured-pro-learn-more-link",
        role: "presentation",
        className: "featured-pro-learn-more-link",
        onClick: function onClick() {
          return _this3.setState({
            showFeaturedProPopOverDetail: true
          });
        },
        key: "1"
      }, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, 'click here.')))] : [/*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: '10px'
        },
        key: "0"
      }, /*#__PURE__*/React.createElement("strong", {
        style: {
          color: green
        }
      }, "Angi Certified Businesses")), /*#__PURE__*/React.createElement("p", {
        key: "1"
      }, 'These Businesses meet our standards of certification, which include:'), /*#__PURE__*/React.createElement("small", {
        key: "2"
      }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "The owner, principal, or relevant manager passing a criminal background check"), /*#__PURE__*/React.createElement("li", null, "Required to have applicable state and local licenses"), /*#__PURE__*/React.createElement("li", null, "Maintain an average star rating of 3.0 or better on our network, if they have at least one review"), /*#__PURE__*/React.createElement("li", null, "Paying to advertise their services"), /*#__PURE__*/React.createElement("li", null, "Meeting any other eligibility criteria required by Angi")))]))));
    }
  }]);
  return FeaturedSPInfoHover;
}(React.Component);
FeaturedSPInfoHover.propTypes = {
  singleFeaturedPro: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = FeaturedSPInfoHover;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/featuredSPInfoHover.js
// module id = 2765
// module chunks = 25